import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SidebarComponent } from "./sidebar.component";

@NgModule({
  declarations: [SidebarComponent],
  imports: [CoreModule],
  exports: [SidebarComponent],
})
export class SidebarModule {}
